import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const DisabledModuleMessage = ({
  isDisabledForNonAutomatedEmails,
  isAbLike
}) => {
  if (isDisabledForNonAutomatedEmails) {
    if (isAbLike) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "layoutBuilder.tiles.disabledForABEmails.email_cart"
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "layoutBuilder.tiles.disabledForNonAutomatedEmails"
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "app.readOnly.title"
  });
};
export default DisabledModuleMessage;